// extracted by mini-css-extract-plugin
export default {"list":"list--PpfE5","name":"name--oYU4m"};